import React, { useState } from "react";
import axios from "axios";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import { useNavigate } from "react-router-dom";
const API_ENDPOINT_SERVER = process.env.REACT_APP_API_ENDPOINT_SERVER;

const StyledGridPopOver = styled(Grid)({
  display: "flex",
  width: "100px",
  marginLeft: 10,
});

// const useStyles = makeStyles((theme) => ({
//   editIcon: {
//     color: "#2D6A4F",
//     cursor: "pointer",
//   },
//   deleteIcon: {
//     color: "#AAC1B0",
//     cursor: "pointer",
//   },
// }));
export default function EditDelete({
  setopenEditModal = () => {},
  setOpenDeleteModal = () => {},
  data = {},
  setEditData = () => {},
  setDeleteData = () => {},
  disabled = false,
  canEdit = true,
  canDelete = true,
  showMagicUrlGenerator = false,
}) {
  // STATES: 0: not called, 1: called, 2: copied, -1: error
  const [copyCalled, setCopyCalled] = useState(0)
  // const classes = useStyles();
  const loginOnline = async (email, password) => {
    const response = await axios.post(`${API_ENDPOINT_SERVER}auth/login`, {
      email: email,
      password: password,
    });
    return response.data.token;
  };
  
  const shortenUrlId = async (longUrl) => {
    try {
      const response = await axios.get(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(longUrl)}`);
      const shortUrlId = response.data.split('tinyurl.com/')[1];
      return shortUrlId; 

    } catch (error) {
      console.error("Error shortening URL:", error);
      throw error;
    }
  };
  
  const createMagicUrl = (data) => {
    const baseUrl = API_ENDPOINT_SERVER;
    const endpoint = "magic";
    const dataset = data.id;
    
    loginOnline('magic@wadhwaniai.org', 'magic@1234')
      .then(async (response_token) => {
        
        const longUrl = `${baseUrl}${endpoint}?dataset=${dataset}&token=${response_token}`;
        try {
          setCopyCalled(1);
          const shortUrlId = await shortenUrlId(longUrl);
          navigator.clipboard.writeText(`${baseUrl}${endpoint}?id=${shortUrlId}`);
          setCopyCalled(2); 
        } catch (error) {
          console.error("Error in URL shortening:", error);
          setCopyCalled(-1);
        }
        finally {
          setTimeout(() => setCopyCalled(0), 1000);
        }
      })
      .catch(error => {
        console.error("Error getting token:", error);
        setCopyCalled(-1);
      });
  };
  
  const navigate = useNavigate();

  const NewFormWithSchema = (schema) => {
    if (!disabled && schema) {
      navigate('/new-form', { state: { passed_schema: schema } });
    }
  };

  return (
    <StyledGridPopOver container sx={{width:'180px'}}>
      <Grid item xs={3}>
      <IconButton disabled={!canEdit}>
        <EditRoundedIcon
          onClick={() => {
            if (!disabled) {
              setopenEditModal(true);
              NewFormWithSchema(data.schema)
              setEditData(data);
            }
          }}
          style={{
            pointerEvents: disabled ? "none" : "auto",
            cursor: !canEdit ? "not-allowed" : (disabled ? "default" : "pointer"),
            color: disabled && "#AAAAAA",
          }}
          />
      </IconButton>
      </Grid>
      <Grid item xs={3}>
      <IconButton disabled={!canDelete}>

        <DeleteRoundedIcon
          onClick={() => {
            if (!disabled) {
              setOpenDeleteModal(true);
              setDeleteData(data);
            }
          }}
          style={{
            pointerEvents: disabled ? "none" : "auto",
            cursor: !canDelete ? "not-allowed" : (disabled ? "default" : "pointer"),
            color: disabled && "#AAAAAA",
          }}
        />
      </IconButton>
      </Grid>
      {showMagicUrlGenerator && <Grid item xs={3}>
        <IconButton>

        <ContentCopyRoundedIcon
          onClick={() => {
            if (!disabled) {
              setCopyCalled(1)
              createMagicUrl(data)
            }
          }}
          style={{
            pointerEvents: disabled ? "none" : "auto",
            cursor: "pointer",
            color: copyCalled === -1 ? "#FF0000" : (copyCalled === 2 ? "#4CAF50" : (copyCalled === 1 ? "#FFA500" : (disabled ? "#AAAAAA" : "inherit"))),
          }}
        />
        {copyCalled !== 0 && (
          <span style={{ fontSize: "12px", position: "absolute",  top: "50%", transform: "translateY(-50%)" }}>
            {copyCalled === -1 ? 'Failed!' : (copyCalled === 1 ? 'Loading...' : 'Copied!')}
          </span>
        )}
        </IconButton>
      </Grid>}
    </StyledGridPopOver>
  );
}
